export default "__VITE_ASSET__1a5b78be__"